import { i18n, defaultNS, flattenResources } from "@whatslly/commons/i18nService";
import translationEN from "./en/translation.json";
import translationES from "./es/translation.json";
import translationPT from "./pt/translation.json";

i18n.addResources("en", defaultNS, flattenResources(translationEN));
i18n.addResources("es", defaultNS, flattenResources(translationES));
i18n.addResources("pt", defaultNS, flattenResources(translationPT));
export default i18n;
